import React, { ChangeEvent, FunctionComponent, PropsWithChildren } from "react";
import { connect, MapStateToProps, MergeProps } from "react-redux";

import { createQA } from "@multiweb/reactUtils";
import { IAppState, QAProps } from "@multiweb/types/react";
import { isWorkflowReadOnly } from "../../../selectors";
import { WorkflowEditorProps } from "../../../types";
import { getEditableControlClassName } from "./utils";

type WfSelectComponentProps = PropsWithChildren <{
    readonly disabled?: boolean;
    readonly name?: string;
    readonly required?: boolean;
    readonly size?: number;
    readonly value: string | number;
    readonly onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
}> & QAProps;

const WfSelectComponent: FunctionComponent<WfSelectComponentProps> = ({ children, name, disabled = false, required = false, size, value, qa, onChange }) => (
    <div {...createQA(qa)} className={getEditableControlClassName(required, disabled)}>
        <select {...{ name, disabled, required, size, value, onChange }}>
            {children}
        </select>
    </div>
);

type WfSelectProps = WfSelectComponentProps & WorkflowEditorProps;

type StateProps = {
    readonly isWorkflowReadOnly: boolean;
};

const mapStateToProps: MapStateToProps<StateProps, WfSelectProps, IAppState> = (state, { hostKey }) => ({
    isWorkflowReadOnly: isWorkflowReadOnly(state, hostKey),
});

const mergeProps: MergeProps<StateProps, undefined, WfSelectProps, WfSelectComponentProps> = ({ isWorkflowReadOnly }, _dispatchProps, ownProps) => ({
    ...ownProps,
    disabled: isWorkflowReadOnly || ownProps.disabled,
});

export const WfSelect = connect(mapStateToProps, undefined, mergeProps)(WfSelectComponent);
